/* Generated USDT deposit adapters unit. */
import { clearPersistedAuthToken, getAuthSessionRevision, getStoredAuthToken } from '@/lib/authStorage';
// Request-local metadata stays in the transport config, never in the financial body.
const guardKey = 'walletFinanceRequestCurrent';
const expiryKey = 'walletFinanceExpiresSession';
const staleRequest = () => Object.assign(new Error('stale_wallet_request'), { code: 'WALLET_REQUEST_STALE' });
export const assertWalletFinanceRequestCurrent = request => {
  const guard = request?.[guardKey];
  if (guard && !guard(request)) throw staleRequest();
};
export const expireWalletFinanceRequestSession = request => {
  if (!request?.[expiryKey]) return false;
  assertWalletFinanceRequestCurrent(request);
  clearPersistedAuthToken();
  return true;
};
export const captureWalletFinanceRequest = ({ isCurrent, getAdapter, expireOnUnauthorized = false }) => {
  const ownerCurrent = typeof isCurrent === 'function' ? isCurrent : expireOnUnauthorized ? () => true : null;
  if (!ownerCurrent) return undefined;
  const token = getStoredAuthToken(), revision = getAuthSessionRevision();
  const current = request => ownerCurrent() && getAuthSessionRevision() === revision && getStoredAuthToken() === token &&
    (request.headers?.get?.('Authorization') || request.headers?.Authorization || '') === (token ? `Bearer ${token}` : '');
  const assertCurrent = request => { if (request?.[guardKey] !== current || !current(request)) throw staleRequest(); };
  const captured = { headers: token ? { Authorization: `Bearer ${token}` } : {}, [guardKey]: current, [expiryKey]: expireOnUnauthorized };
  assertCurrent(captured);
  return {
    ...captured,
    adapter: async request => {
      // Axios has completed async interceptors and body transforms at this point.
      assertCurrent(request);
      try {
        const response = await getAdapter()(request);
        assertCurrent(request);
        return response;
      } catch (error) {
        // Suppress stale 401/429 before shared response side effects can run.
        assertCurrent(request);
        throw error;
      }
    },
  };
};
